import { createSlice } from "@reduxjs/toolkit";
import { getProduct, submitProduct, deleteProduct } from "./Utils/productUtils";
import Swal from 'sweetalert2';

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
    },
    products: [],
    pagination: {},
    loading: false,
    error: null,
    currentProduct: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        description: "",
        price: "",
        gimmick_price: "",
        how_to_use: "",
        tiktok_url: "",
        shopee_url: "",
        tokopedia_url: "",
        photo: null,
    }
};

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentProduct = { ...state.currentProduct, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentProduct = initialState.currentProduct;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters    : (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getProduct
            .addCase(getProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.products = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Handle submitProduct
            .addCase(submitProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitProduct.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Produk Berhasil Disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                // Kalau data baru, tambah ke daftar
                if (!state.products.find(product => product.id === action.payload.id)) {
                    state.products.push(action.payload);
                } else {
                    // Update data yang sudah ada
                    const index = state.products.findIndex(product => product.id === action.payload.id);
                    state.products[index] = action.payload;
                }
            })
            .addCase(submitProduct.rejected, (state, action) => {
                state.loading = false;
            })
            // Handle deleteProduct
            .addCase(deleteProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteProduct.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(deleteProduct.rejected, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: action.payload,
                    confirmButtonText: 'OK'
                });
            })
    }
});
export const { setFormData, resetFormData, setFilters, resetFilters } = productSlice.actions;
export default productSlice.reducer;